import { styled } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

const { carbon, midnight } = colorsPalettes;

export const Header = styled(Stack)`
    gap: 16px;
    margin-bottom: 16px;

    & .DropdownButton {
        background: ${carbon[0]};
        height: auto !important;
        border: 1px solid ${midnight[50]};
        border-radius: 3px;
    }

    @media print {
        display: none;
    }
`;

export const Title = styled(Flex)`
    ${setFontVariant("h5_2", carbon[500])};
    align-items: center;
    gap: 16px;
    margin: 0;
`;

export const Section = styled(Flex)`
    justify-content: space-between;
    align-items: center;
`;

export const ActionsContainer = styled(Flex)`
    gap: 4px;
    align-items: center;
`;
